var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isShow
    ? _c("div", { staticClass: "igc-face-img" }, [
        _c("div", { ref: "box", staticClass: "ig-img-box" }, [
          _c("div", { on: { click: _vm.out } }, [
            _c(
              "div",
              {
                staticClass: "ig--close",
                style: { background: _vm.mColor(4) },
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.next($event)
                  }
                }
              },
              [
                _c("sui-icon", {
                  staticClass: "ig--icon",
                  attrs: { name: "close", fill: _vm.mColor(7) }
                })
              ],
              1
            ),
            _c("img", { attrs: { src: _vm._url, alt: "" } })
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }